var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcSearch = function SvgIcSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "5028D640-E476-45E0-A2E5-CA76EE5CE8A9")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wyszukiwanie",
    transform: "translate(-183.000000, -19.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.804328,40.9108234 L202.254328,36.3688234 C205.744118,31.8832386 205.144148,25.457214 200.884314,21.695178 C196.62448,17.9331419 190.173579,18.132251 186.153866,22.1498378 C182.134152,26.1674246 181.931629,32.6182184 185.69141,36.880043 C189.451191,41.1418675 195.876897,41.7452384 200.364328,38.2578234 L204.904328,42.8128234 C205.153575,43.065113 205.493024,43.2077695 205.847667,43.2092826 C206.202311,43.2107717 206.542955,43.0709939 206.794328,42.8208234 L206.804328,42.8128234 C207.059216,42.5630599 207.203677,42.2217642 207.205574,41.8649088 C207.207433,41.5080533 207.066573,41.165256 206.814328,40.9128234 L206.804328,40.9058234 L206.804328,40.9108234 Z M185.754328,29.8028234 C185.753924,26.550856 187.712551,23.6188733 190.716861,22.374119 C193.721171,21.1293647 197.179482,21.8169861 199.479113,24.1163313 C201.778745,26.4156765 202.466796,29.8739023 201.222415,32.8783672 C199.978035,35.882832 197.046296,37.8418234 193.794328,37.8418234 C189.354349,37.8418234 185.754881,34.2428022 185.754328,29.8028234 Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_search.9897f26f.svg";
export { ForwardRef as ReactComponent };